import { render, staticRenderFns } from "./ProcedureDescriptionForm.vue?vue&type=template&id=1104918f"
import script from "./ProcedureDescriptionForm.vue?vue&type=script&lang=js"
export * from "./ProcedureDescriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports